import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useDime, useDimeConvertedToPaid, useDimeDialogState, } from '@office-start/dime-service';
import { DimeExperience } from '@office-start/dime-types';
import { useMemo } from 'react';
export var useShowDime = function () {
    var _a, _b;
    var context = useOfficeComponentContext();
    var dimeReactDialogState = useDimeDialogState();
    var dimeReactConvertedToPaid = useDimeConvertedToPaid();
    var showDime = useDime({
        experiences: [DimeExperience.Fre],
        disableSubscriptionCheck: (_b = (_a = context.data) === null || _a === void 0 ? void 0 : _a.inMockMode) !== null && _b !== void 0 ? _b : false,
    });
    return useMemo(function () {
        if (showDime) {
            return {
                dimeActive: dimeReactDialogState === 'Open',
                dimeEnabled: true,
                showDime: function (targetUrl) {
                    showDime(DimeExperience.Fre, targetUrl);
                },
                userConvertedToPaid: dimeReactConvertedToPaid !== null && dimeReactConvertedToPaid !== void 0 ? dimeReactConvertedToPaid : false,
            };
        }
        return {
            dimeActive: false,
            dimeEnabled: false,
            showDime: undefined,
            userConvertedToPaid: false,
        };
    }, [dimeReactConvertedToPaid, dimeReactDialogState, showDime]);
};
//# sourceMappingURL=useShowDime.js.map